import React from 'react';
import {
  Box,
  TextField,
  Typography,
  Paper,
  InputAdornment,
} from '@mui/material';
import { AttachMoney } from '@mui/icons-material';

const AmountStep = ({ amount, onAmountChange }) => {
  const handleAmountChange = (e) => {
    const value = e.target.value;
    // Only allow numbers and decimals
    if (value === '' || /^\d*\.?\d{0,2}$/.test(value)) {
      onAmountChange(value);
    }
  };

  const formatCurrency = (value) => {
    if (!value || parseFloat(value) === 0) return '';
    return new Intl.NumberFormat('en-AE', {
      style: 'currency',
      currency: 'AED',
      minimumFractionDigits: 2
    }).format(parseFloat(value));
  };

  return (
    <Box>
      <Typography variant="h6" gutterBottom sx={{ mb: 3 }}>
        How much would you like to add?
      </Typography>

      <TextField
        fullWidth
        label="Amount"
        value={amount}
        onChange={handleAmountChange}
        placeholder="0.00"
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <Typography variant="h6" color="primary" sx={{ fontWeight: 600 }}>
                AED
              </Typography>
            </InputAdornment>
          ),
        }}
        sx={{
          mb: 3,
          '& .MuiInputBase-input': {
            fontSize: '2rem',
            fontWeight: 500,
            textAlign: 'center'
          }
        }}
      />

      <Typography variant="caption" color="text.secondary" display="block" sx={{ mb: 3, textAlign: 'center' }}>
        Minimum: AED 10  •  Maximum: AED 100,000
      </Typography>

      {amount && parseFloat(amount) > 0 && (
        <Paper
          sx={{
            p: 3,
            bgcolor: 'primary.main',
            color: 'primary.contrastText',
            textAlign: 'center',
            mt: 3
          }}
        >
          <Typography variant="caption" sx={{ opacity: 0.9, mb: 1, display: 'block' }}>
            You're adding
          </Typography>
          <Typography variant="h3" fontWeight={700}>
            {formatCurrency(parseFloat(amount))}
          </Typography>
          <Typography variant="caption" sx={{ opacity: 0.9, mt: 1, display: 'block' }}>
            to your wallet
          </Typography>
        </Paper>
      )}

      {/* Quick amount buttons */}
      <Box sx={{ mt: 4 }}>
        <Typography variant="body2" color="text.secondary" gutterBottom>
          Quick amounts:
        </Typography>
        <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
          {[100, 500, 1000, 2000, 5000, 10000].map((quickAmount) => (
            <Paper
              key={quickAmount}
              sx={{
                px: 2,
                py: 1,
                cursor: 'pointer',
                transition: 'all 0.2s',
                border: amount === quickAmount.toString() ? 2 : 1,
                borderColor: amount === quickAmount.toString() ? 'primary.main' : 'divider',
                '&:hover': {
                  borderColor: 'primary.main',
                  bgcolor: 'action.hover'
                }
              }}
              onClick={() => onAmountChange(quickAmount.toString())}
            >
              <Typography variant="body2" fontWeight={amount === quickAmount.toString() ? 600 : 400}>
                AED {quickAmount.toLocaleString()}
              </Typography>
            </Paper>
          ))}
        </Box>
      </Box>
    </Box>
  );
};

export default AmountStep;
